import { Organization } from './others.model';
import { PaginationRequestParams, SortDirection } from './pagination.model';
import { Person } from './people.model';

export enum PerformanceType {
    AUDIO = 'audio',
    VIDEO = 'video'
}

export interface Performance {
    id: number;
    cdbId: number;
    mp3Url: string;
    hlsUrl: string;
    cover: string;
    type: PerformanceType;
    composers: Person[];
    performers: Person[];
    organizations: Organization[];
    name: string;
    genre: Genre[];
    stages: PerformanceEditionStage[];
    collectionsId: number[];
    isNews: boolean;
    isFavorite: boolean;
    isPremium: boolean;
    popularity: number;
    length: number;
    description?: string;
    order?: number;
    _chosenForUser?: boolean;
    _stages?: string | string[];
    _playedAt?: string;
    _performanceCategory: string | string[];
    _isCompetition?: boolean;
}

export interface PerformanceRequestParams extends PaginationRequestParams {
    composers?: Array<string | number>;
    performers?: Array<string | number>;
    stages?: Array<string | number>;
    type?: PerformanceType | PerformanceType[];
    performanceCategory?: Array<string | number>;
    isNews?: boolean;
    isFavorite?: boolean;
    isRecommended?: boolean;
    isCompetition?: boolean;
    'order[id]'?: SortDirection;
    'order[popularity]'?: SortDirection;
    _chosenForUser?: boolean;
    _isolatedMetaKey?: string;
}

export interface Genre {
    id: number;
    name: string;
}

export interface PerformanceEditionStage {
    id: number;
    isFinal: boolean;
    name: string;
    edition: {
        id: number;
        year: string;
        name: string;
    };
}


export interface PerformanceRecentlyPlayed {
    performance: Performance;
    playedAt: string;
}

export interface PerformanceRecentlyPlayedRequestParams extends PaginationRequestParams {
    type?: PerformanceType | PerformanceType[];
    'order[id]'?: SortDirection;
    'order[playedAt]'?: SortDirection;
}

// metadata

export interface FavouriteMetadata {
    numberOfPerformances?: number;
    totalLengthOfPerformances?: number;
    numberOfAudioPerformances?: number;
    numberOfVideoPerformances?: number;
    totalLengthOfAudioPerformances?: number;
    totalLengthOfVideoPerformances?: number;
}

export interface PerformanceMetadata {
    performanceCategorise: PerformanceMetadataCategorise[];
}

export interface PerformanceMetadataCategorise {
    performanceCategory: PerformanceMetadataCategory,
    totalNumerOfPerformances?: number;
}

export interface PerformanceMetadataCategory {
    id?: number;
    isMain?: boolean;
    name?: string;
}

export interface PerformanceCategory {
    id?: number;
    isMain?: boolean;
    showOnVideoPage?: boolean;
    showOnAudioPage?: boolean;
    name?: string;
    showOnHomePage?: boolean;
}
